import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "href", "linkMode", "onClick", "tabIndex", "use"],
  _excluded2 = ["display"];
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { jsx as _jsx } from "react/jsx-runtime";
export function PolymorphicLink(_ref) {
  let {
      children,
      href,
      linkMode,
      onClick,
      tabIndex,
      use
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  // sometimes you don't want a link at all
  if (!href) {
    const {
        display
      } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded2);
    const Wrapper = display === 'flex' ? Flex : View;
    return /*#__PURE__*/_jsx(Wrapper, Object.assign({}, rest, {
      children: children
    }));
  }
  if (linkMode === 'react-router') {
    return /*#__PURE__*/_jsx(RouterLink, Object.assign({
      to: href,
      use: use,
      onClick: onClick,
      tabIndex: tabIndex
    }, props, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(Link, Object.assign({
    href: href,
    use: use,
    onClick: onClick,
    tabIndex: tabIndex
  }, props, {
    children: children
  }));
}